module.exports = __webpack_public_path__ + "img/za.e3c0ebae.jpg";